module.exports = "<div class=login__logo></div> <div class=\"login__title h1\" ng-if=!$ctrl.accessDenied>Let the magic begin</div> <button class=\"button button--primary button--full\" ng-if=\"!$ctrl.accessDenied && $ctrl.isLoggedOut\" ng-click=$ctrl.goToLogin()> Log in </button> <div class=login__error ng-if=$ctrl.accessDenied> <p>{{$ctrl.accessDeniedReason.message}}</p> <span>{{$ctrl.accessDeniedReason.error}}</span> <p class=login__timer ng-if=$ctrl.isCountDownVisible>Logging out in {{$ctrl.timer}} seconds</p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.template.html
// module id = 544
// module chunks = 0